module.exports = {
  familyName: 'Open Sans',
  category: 'sans-serif',
  capHeight: 1462,
  ascent: 2189,
  descent: -600,
  lineGap: 0,
  unitsPerEm: 2048,
  xHeight: 1096,
  xWidthAvg: 955
};
